/**
 * Set of common confirmation dialogs.
 * Props vary per dialog such as open and callbacks.
 */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Button } from "@mui/material";

export function SaveAlertDialog({ open, setOpen, setsavingchanges }: any) {
  const handleClose = () => {
    setOpen(false);
  };
  const handleAgree = () => {
    setsavingchanges(true);
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Guardar cambios"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Esto cambiará la información de la base de datos, ¿está seguro de
          continuar?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button onClick={handleAgree} autoFocus>
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export function DeleteDialog({
  tittle = "Desactivar usuario",
  open,
  setOpen,
  setsavingchanges,
  question = "El usuario ya no tendra acceso, desea continuar?",
  onCancel = () => { }
}: any) {
  const handleClose = () => {
    setOpen(false);
  };
  const handleAgree = () => {
    setsavingchanges(true);
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{tittle}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {question}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => {
          if (onCancel) onCancel();
          handleClose();
        }}>Cancelar</Button>
        <Button onClick={handleAgree} autoFocus>
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export function SuccesUploadAlertDialog({ open, setOpen, fail }: any) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {fail ? "Error al actualizar información" : "Guardado exitosamente"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {fail
            ? "No se pudo actualizar la información"
            : "La información se ha actualizado exitosamente"}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
